import React, { useState } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'

import { SelectInput } from '@/modules/base/components/inputs'
import Search from '@/modules/base/components/search/search'
import ThemeInterface from '@/theme-interface'
import { MultiSelectTypes } from '../constants'
import { ClickAwayListener } from '@mui/material'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  inputs: {
    display: 'flex',
    width: 438,
    background: theme.backgroundColor,
  },
  search: {
    flex: '1 0 65%',
    border: `1px solid ${theme.borderColors.default}`,
    borderLeft: 'none',
    borderRadius: '0px 4px 4px 0px',
    '& > *': {
      border: 'none',
      flexDirection: 'row',
    },
  },
  select: {
    border: `1px solid ${theme.borderColors.default}`,
    borderRadius: '4px 0px 0px 4px',
  },
  focused: {
    borderColor: theme.borderColors.outline,
  },
}))
const selectControlStyles = (base) => ({
  ...base,
  borderBottom: 'none',
  paddingLeft: 10,
})
const selectMenuStlyes = (base) => ({
  ...base,
  marginTop: 0,
})

interface MultiSelectInputProps {
  activeSelectType: MultiSelectTypes,
  groups: Array<{ type: MultiSelectTypes, label: string }>,
  popperOpen: boolean,
  placeholder?: string,
  onOpenPopper: () => void,
  onClosePopper: () => void,
  onSearchTermChange: (searchTerm: string) => void,
  onTypeChange: (option: { type: MultiSelectTypes }) => void,
}

const MultiSelectInput = (props: MultiSelectInputProps) => {
  const classes = useStyles()
  const [searchFocused, setSearchFocused] = useState<boolean>(false)
  const [selectFocused, setSelectFocused] = useState<boolean>(false)
  const {
    activeSelectType,
    groups,
    placeholder,
    popperOpen,
    onOpenPopper,
    onClosePopper,
    onSearchTermChange,
    onTypeChange,
  } = props

  const onFocus = () => {
    setSearchFocused(true)
  }
  const onBlur = () => {
    setSearchFocused(false)
  }
  const onSelectFocus = () => {
    setSelectFocused(true)
  }
  const onSelectBlur = () => {
    setSelectFocused(false)
  }

  return (
    <div className={classes.inputs}>
      {groups.length > 1 && (
        <SelectInput
          className={clsx(classes.select, (searchFocused || selectFocused || popperOpen) && classes.focused)}
          styles={{
            control: selectControlStyles,
            menu: selectMenuStlyes,
          }}
          notAsync
          isInline
          allowCreate={false}
          value={activeSelectType}
          options={groups}
          customSelectOptions={{
            valueKey: 'type',
            labelKey: 'label',
          }}
          onFocus={onSelectFocus}
          onBlur={onSelectBlur}
          handleChange={(option) => {
            onTypeChange(option)
            setSelectFocused(false)
          }}
        />
      )}
      <ClickAwayListener onClickAway={onClosePopper}>
        <Search
          hideClear
          placeholder={placeholder}
          customClass={clsx(classes.search, (searchFocused || popperOpen) && classes.focused)}
          onFocus={onFocus}
          onBlur={onBlur}
          onClick={() => { onOpenPopper?.() }}
          onSearchInputChange={onSearchTermChange} />
      </ClickAwayListener>
    </div>
  )
}

export default MultiSelectInput
